// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import * as React from 'react'
import type { HeadFC, PageProps } from 'gatsby'
import { SEO } from '../../components/seo'
import Banner from '../../components/global/banner/Banner'
import Banners from '../../components/global/banner/Banner.types'
import PageLayout from '../../components/global/pageLayout/PageLayout'
import Offerings from '../../components/global/offerings/Offerings'
import { productOfferings } from '../../components/global/offerings/Offerings.types'
import AiUseCases from '../../components/home/aiUseCases/AiUseCases'
import Intersticial from '../../components/global/intersticialCustom/Intersticial'
import Intersticials from '../../components/global/intersticialCustom/Intersticials.types'
import ResourceTemplate from '../../components/home/resourceAIandRD/ResourceTemplate'
import ExtendedInterticial from '../../components/global/extendedIntersticial/ExtendedIntersticial'
import extendedIntersticials from '../../components/global/extendedIntersticial/ExtendedIntersticial.types'

const SolutionsEnterprisePage: React.FC<PageProps> = () => {
  return (
    <PageLayout>
      <Banner {...Banners.solutionsEnterprise} />
      <Offerings {...productOfferings.enterpriseDeployments} />
      <Offerings {...productOfferings.enterpriseBenefits} />
      <Offerings {...productOfferings.enterpriseTransition} />
      <ExtendedInterticial {...extendedIntersticials.secureCloud} />
      <AiUseCases />
      <Intersticial {...Intersticials.enterpriseBenefits} />
      <Intersticial {...Intersticials.performanceData} />
      <Intersticial {...Intersticials.premiumCustomerService} />
      <ResourceTemplate page="cs" />
      <Intersticial {...Intersticials.getStarted} />
    </PageLayout>
  )
}

export default SolutionsEnterprisePage

export const Head: HeadFC = () => (
  <SEO
    title="Intel® Tiber™ AI Cloud - Solutions for the Enterprise"
    description="Unlock scalable AI for your company with Tiber™ AI Cloud: superior performance, flexibility, and security. Seamlessly transition with 24/7 support."
  />
)
